import { IRoute } from "@src/routes";
import ListBeneficiaryPage from "./pages/ListBeneficiaryPage";
import ListProgramBeneficiaryPage from "./pages/ListProgramBeneficiaryPage";
import ViewProgramBeneficiaryPage from "./pages/ViewProgramBeneficiaryPage";
import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/pbm/programs/:programCode/beneficiaries/:id",
    key: "PBM_PROGRAM_BENEFICIARY_VIEW",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ViewProgramBeneficiaryPage,
  },
  {
    menu: { label: "Beneficiários do Programa" },
    path: "/pbm/programs/:programCode/beneficiaries",
    key: "PBM_PROGRAM_BENEFICIARIES",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListProgramBeneficiaryPage,
  },
  {
    menu: { label: "Programas do Beneficiário" },
    path: "/pbm/beneficiaries/:id",
    key: "PBM_BENEFICIARY",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListProgramBeneficiaryPage,
  },
  {
    menu: { label: "Beneficiários" },
    path: "/pbm/beneficiaries",
    key: "PBM_BENEFICIARIES",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListBeneficiaryPage,
  },
];

export default routes;
